module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/domofon-1-83fbbb2b9519f5bf1df5199527a42e15.png";